module.exports = __webpack_public_path__ + "img/220_grit_sand_block.74931cc8.webp";